import styles from './styles.module.css';
import Image from "@/shared/components/Image/new";

const EmbedGallery = ({ content, type, classList, image }) => {
    return (
        <div className={`${styles['custom-embed-gallery']} ${classList}`}>
            <a href={content.url} target={'_blank'} style={{ position: 'relative' }} rel='noreferrer noopener'>
                <img src='/img/galerias-hd.svg' className={`${styles['gallery-watermark']}`} alt="" />
                <Image
                    src={type.domain + image}
                    layout={`responsive`}
                    objectFit={`cover`}
                    alt={content.title}
                    width={870}
                    height={580}
                    className={styles['img-gallery']}
                />
                <div className={`${styles['text-container']}`}>
                    <h3>{content.title}</h3>
                </div>
            </a>
        </div>
    )
}

export default EmbedGallery;